<ng-container *ngIf="tab">
	<span
		class="icon-caption panel-title"
		*ngIf="tab.config && tab.config.title && tab.config.title.label"
		[dcrHTMLKey]="tab.config.title.label.key"
		[innerHTML]="tab.config.title.label.toString()"
	></span>
	<icon
		type="info-circle"
		class="info-circle text-14 color-primary"
		*ngIf="tab.config && tab.config.title && tab.config.title.infoBubble"
		[tooltip]="infoBubble"
		[analytic-data]="{ linkName: 'tooltip_' + tab.config.title.label.key }"
	>
	</icon>
	<ng-template #infoBubble> <section [innerHTML]="tab.config.title.infoBubble"></section> </ng-template>
	<dcr-cell-content [config]="tab.config.title"></dcr-cell-content>
</ng-container>
